module.exports = __webpack_public_path__ + "27fd2a482dd9b87983cadcd09a25ab94.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003AJP.png
// module id = 1489
// module chunks = 0